export default "__VITE_ASSET__a2388775__"